module.exports = __webpack_public_path__ + "img/person2.6ecc99a0.png";